import React from 'react'
import { Button, IconButton, Icon, Whisper, Tooltip } from 'rsuite'

export default function TooltipButton({
  onClick,
  children,
  disabled,
  icon,
  tooltip,
  iconStyle,
  isStart,
  iconClass,
  buttonClass,
  ...props
}) {
  return (
    <Whisper placement="top" trigger="hover" speaker={<Tooltip>{tooltip}</Tooltip>}>
      {icon ? (
        <IconButton
          size="sm"
          appearance="ghost"
          className={buttonClass || ''}
          icon={
            <Icon
              icon={icon}
              style={iconStyle}
              className={
                iconClass ? iconClass : isStart ? 'bt-gost-icon-radius' : 'bt-gost-icon-none-radius'
              }
            />
          }
          disabled={disabled}
          onClick={onClick}
          {...props}
        >
          {children}
        </IconButton>
      ) : (
        <Button onClick={onClick} disabled={disabled} size="sm" appearance="ghost" {...props}>
          {children}
        </Button>
      )}
    </Whisper>
  )
}
